<template>
  <div>
    <template v-if="confirmWithSuccess">
      <GroupOrderHeaderBand
        :sectionDescription="
          `You'll receive an email confirmation once your order has shipped.`
        "
        :isSuccess="confirmWithSuccess"
        :showFixedHeader="true"
      />
      <div class="group-order-container">
        <GroupOrderRecipientInfo
          :recipient="recipient"
          :confirmWithSuccess="confirmWithSuccess"
        />
        <GroupOrderCartList
          :selectedVariants="selectedVariants"
          :confirmWithSuccess="confirmWithSuccess"
        />
        <p class="footer-info">
          For more information on <strong>Gemnote</strong> and corporate
          gifting. Please visit our
          <strong>
            <span
              class="hoverable-text"
              @click="openWindowTab('https://www.gemnote.com')"
              >website</span
            >
          </strong>
          and
          <strong>
            <span
              class="hoverable-text"
              @click="openWindowTab('https://www.gemnote.com/blog')"
              >blog!</span
            ></strong
          >
        </p>
      </div>
    </template>
    <template v-else>
      <h5>Please confirm your redemption to see all info related.</h5>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GroupOrderHeaderBand from './GroupOrderHeaderBand'
import GroupOrderRecipientInfo from './GroupOrderRecipientInfo'
import GroupOrderCartList from './GroupOrderCartList'

export default {
  name: 'RecipientSuccessGroupOrder',
  components: {
    GroupOrderHeaderBand,
    GroupOrderRecipientInfo,
    GroupOrderCartList
  },
  computed: {
    ...mapState({
      recipient: state => state.groupOrder.recipient,
      selectedVariants: state => state.groupOrder.selectedVariants,
      confirmWithSuccess: state => state.groupOrder.confirmWithSuccess
    })
  },
  methods: {
    openWindowTab(url) {
      let win = window.open(url, '_blank')
      win.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.hoverable-text {
  text-decoration: none;
}

.footer-info {
  font-size: 0.875rem;
}

.group-order-container {
  position: relative;
  top: 6rem;
  p {
    padding: 2rem;
  }
}

@media (max-width: 1100px) {
  .group-order-container {
    width: 85%;
  }
}

@media (max-width: 575.98px) {
  .footer-info {
    padding: 2rem 0rem;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .footer-info {
    padding: 2rem 0rem;
  }
}
</style>
